/* eslint-disable import/no-anonymous-default-export */
/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react'
import { Link } from '@reach/router'
import { useSelector } from 'react-redux'

export default function ({
  state,
  to,
  href,
  key,
  disabled,
  children,
  onClick,
  title,
  customCss,
  onMouseEnter
}) {
  const theme = useSelector(state => state.theme)
  return to
    ? (
      <Link
        key={key}
        to={to}
        state={state}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        css={css`
            font-size: var(--link);
            font-weight: 600;
            color: ${theme
               ? 'var(--darkColor)'
               : 'var(--lightColor)'};
            :hover {
               color: var(--successColor);
            }
            ${disabled && 'pointer-events:none'};

            ${customCss && customCss};
         `}
      >
        {children}
      </Link>
      )
    : (
      <a
        css={css`
            font-size: 1.5rem;
            font-weight: 600;
            color: ${theme
               ? 'var(--darkColor)'
               : 'var(--lightColor)'};
            :hover {
               color: var(--successColor);
            }
            ${disabled && 'pointer-events:none'};
            ${customCss && customCss};
         `}
        href={href}
        onClick={onClick}
        title={title}
        target='_blank'
        rel='noopener noreferrer'
      >
        {children}
      </a>
      )
}
